import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  scrollArea: {flex: 1},
  scrollContent: {padding: 20, paddingBottom: 88},
  input: {
    width: '100%', height: 52, paddingHorizontal: 16, backgroundColor: '#0a1c1c', borderWidth: 1,
    borderColor: 'rgba(235, 255, 247, 0.16)', borderRadius: 8, color: '#ffffff', fontSize: 17,
    fontFamily: 'POI Aeronaut', fontVariant: ['tabular-nums']
  },
  inputWithIconText: {paddingLeft: 48},
  inputIcon: {position: 'absolute', left: 14, top: 16, zIndex: 1},
  depositSuccessGlowImage: {
    position: 'absolute', left: '50%', top: '50%', width: 320, height: 320, marginLeft: -160, marginTop: -160,
    zIndex: 0
  },
  depositSuccessGlowFill: {width: '100%', height: '100%'},
  depositSuccessBurst: {
    position: 'absolute', left: '50%', top: '50%', borderColor: 'rgba(39, 233, 166, 0.45)',
    backgroundColor: 'transparent', zIndex: 0
  },
  depositSuccessIconLayer: {zIndex: 1},
  mediumText: {fontWeight: '500'}, boldText: {fontWeight: '700'}
});
